export const LADE_AUSWAHLWERTE_NOTENEINGABE = "ladeAuswahlwerteNoteneingabe";